import { Component } from 'react';
import { options } from './config';
import CheckboxDropdown from '../CheckboxDropdown';
import { withTranslation } from 'react-i18next';

class CommerceFilterIntent extends Component {
    constructor() {
        super();

        this.onApply = this.onApply.bind(this);

        this.url = new URL(window.location);
        this.intent = this.url.searchParams.get('intent');
    }

    onApply(values) {
        const selectedOptions = options(this.props.t).filter((item) => values.includes(item.value));
        this.props.handleSelectChange(selectedOptions);
    }

    render() {
        const { t } = this.props;
        return (
            <div className="intent-container">
                <CheckboxDropdown
                    options={options(t)}
                    label={t('commerce.detail.intent.label')}
                    alreadySelected={this.intent?.split(',')?.map((item) => Number(item))}
                    onApply={this.onApply}
                />
            </div>
        );
    }
}

export default withTranslation()(CommerceFilterIntent);
